import { render } from "./CreatorKnowledgeResourcesView.vue?vue&type=template&id=15ed0ad3&scoped=true"
import script from "./CreatorKnowledgeResourcesView.vue?vue&type=script&lang=js"
export * from "./CreatorKnowledgeResourcesView.vue?vue&type=script&lang=js"

import "./CreatorKnowledgeResourcesView.vue?vue&type=style&index=0&id=15ed0ad3&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ed0ad3"]])

export default __exports__